/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { Dropdown } from 'antd';
import isEmpty from 'lodash/isEmpty';
import isArray from 'lodash/isArray';
import isEqual from 'lodash/isEqual';
import cn from 'classnames';
import { ReactComponent as ArrowDownIcon } from 'assets/icons/New/arrow-down-icon.svg';
import { FILTER_DROPDOWN_TYPE } from 'helpers/constants';
import FilterDropdownList from 'components/New/FilterDropdown/List';
import FilterDropdownChoosing from 'components/New/FilterDropdown/Choosing';
import FilterDropdownDate from 'components/New/FilterDropdown/Date';
import FilterDropdownFooter from 'components/New/FilterDropdown/Footer';
import { ICON_MAPPING } from './constants';
import { getIsDefaultFilterItem } from './utils';
import classes from './FilterBar.module.scss';

const FilterItem = ({
  item = {},
  isReset,
  isDisabled,
  children,
  defaultChecks,
  defaultDate,
  onApply,
  onReset,
}) => {
  const [open, setOpen] = useState(false);
  const [checks, setChecks] = useState(item.dropdown?.type === FILTER_DROPDOWN_TYPE.DATE ? {} : []);
  const [dateVal, setDateVal] = useState(null);
  const appliedFilterLength =
    item.dropdown?.type === FILTER_DROPDOWN_TYPE.LIST ? defaultChecks?.length : 0;
  const isDefaultFilter = getIsDefaultFilterItem(defaultChecks, defaultDate);

  const hasDropdown = !isEmpty(item.dropdown);
  const liItem = (
    <li
      className={cn(classes.item, {
        [classes.reset]: isReset,
        [classes.disabled]: isDisabled,
        [classes.hasValue]: !isDefaultFilter,
      })}>
      {children || (
        <>
          <span className={classes.icon}>{item.icon || ICON_MAPPING[item.type]}</span>
          <span className={classes.label}>
            {item.label}
            {appliedFilterLength > 0 && <> ({appliedFilterLength})</>}
          </span>
          <span className={classes.arrow}>
            <ArrowDownIcon />
          </span>
        </>
      )}
    </li>
  );
  const handleOpenChange = (flag) => {
    setOpen(flag);
  };

  useEffect(() => {
    if (open) {
      if (!isEqual(defaultChecks, checks)) {
        setChecks(defaultChecks);
      }
      if (!isEqual(defaultDate, dateVal)) {
        setDateVal(defaultDate);
      }
    }
  }, [open]);

  if (!hasDropdown) {
    return liItem;
  }

  return (
    <Dropdown
      menu={{
        items: [],
      }}
      dropdownRender={() => {
        return (
          <div className={classes.dropdownContent}>
            {item.dropdown?.type === FILTER_DROPDOWN_TYPE.LIST && (
              <FilterDropdownList
                {...(item.dropdown?.setting || {})}
                items={item.dropdown?.options || []}
                checks={checks}
                setChecks={setChecks}
              />
            )}
            {item.dropdown?.type === FILTER_DROPDOWN_TYPE.CHOOSING && (
              <FilterDropdownChoosing
                {...(item.dropdown?.setting || {})}
                checks={checks}
                setChecks={setChecks}
                items={item.dropdown?.options || []}
              />
            )}
            {item.dropdown?.type === FILTER_DROPDOWN_TYPE.DATE && (
              <FilterDropdownDate
                {...(item.dropdown?.setting || {})}
                items={{
                  field: item.dropdown?.fieldItems || [],
                  method: item.dropdown?.methodItems || [],
                }}
                checks={checks}
                setChecks={setChecks}
                dateVal={dateVal}
                setDateVal={setDateVal}
              />
            )}
            <FilterDropdownFooter
              hasValue={!getIsDefaultFilterItem(checks, dateVal)}
              onApply={() => {
                setOpen(false);
                onApply(checks, dateVal);
              }}
              onReset={() => {
                setChecks(defaultChecks);
                setOpen(false);
                onReset(defaultChecks, dateVal);
              }}
            />
          </div>
        );
      }}
      trigger={['click']}
      onOpenChange={handleOpenChange}
      open={open}
      overlayClassName={classes.dropdownOverlay}>
      {liItem}
    </Dropdown>
  );
};

export default FilterItem;
